import { el } from "../utils/dom";

/**
 * Shared LoadingState / EmptyState / ErrorState blocks. Every async panel in
 * the app renders one of these instead of ever fabricating placeholder data.
 */

export function renderLoadingState(label = "Loading…"): HTMLElement {
  return el("div", { className: "state-block", role: "status" }, [
    el("div", { className: "state-block__spinner" }),
    el("span", {}, [label]),
  ]);
}

export interface EmptyStateOptions {
  title?: string;
  hint?: string;
}

export function renderEmptyState(message: string, options: EmptyStateOptions = {}): HTMLElement {
  const children: HTMLElement[] = [];
  if (options.title) children.push(el("p", { className: "state-block__title" }, [options.title]));
  children.push(el("p", {}, [message]));
  if (options.hint) children.push(el("p", { className: "state-block__hint" }, [options.hint]));
  return el("div", { className: "state-block" }, children);
}

export interface ErrorStateOptions {
  title?: string;
  onRetry?: () => void;
  retryLabel?: string;
}

export function renderErrorState(message: string, options: ErrorStateOptions = {}): HTMLElement {
  const children: HTMLElement[] = [
    el("p", { className: "state-block__title" }, [options.title ?? "Couldn't load this"]),
    el("p", {}, [message]),
  ];
  if (options.onRetry) {
    children.push(
      el(
        "button",
        { className: "btn btn-ghost btn-sm", onclick: options.onRetry },
        [options.retryLabel ?? "Retry"]
      )
    );
  }
  return el("div", { className: "state-block state-block--error" }, children);
}

/** Unavailable state — distinct wording from "error" for degraded/disabled/unauthorized panels. */
export function renderUnavailableState(message: string, hint?: string): HTMLElement {
  return renderEmptyState(message, { title: "Unavailable", hint });
}
